import type {
  Options,
  CategoryKey,
  ScoreKey,
  ScoreOptions,
} from "~/sdks/LocalContent/types";
import type { TransformedScoresMenuData } from "./types";

/**
 * Transforms the scores menu data by filtering out hidden categories and scores,
 * and sorting them by their order.
 *
 * This function is used to prepare the scores menu data for rendering in the UI.
 *
 * @param scoresMenu
 * @returns
 */
export function transformScoresMenuData(
  scoresMenu: Options["scoresMenu"]
): TransformedScoresMenuData {
  return {
    ...(scoresMenu || {}),
    categories: Object.entries(scoresMenu?.categories || {})
      .filter(([, category]) => category.hide !== true)
      .sort(([, a], [, b]) => (a.order ?? 0) - (b.order ?? 0))
      .map(
        // Map categories to the expected format so we can loop through them
        ([categoryKey, category]) =>
          [
            categoryKey as CategoryKey,
            {
              ...category,
              // Sort scores by order within each category
              scores: Object.entries(category.scores || {})
                .filter(([, score]) => score.hide !== true)
                .sort(([, a], [, b]) => (a.order ?? 0) - (b.order ?? 0)),
            },
          ] as [
            CategoryKey,
            typeof category & {
              scores: [ScoreKey, ScoreOptions][];
            },
          ]
      ),
  };
}
